function creatorCampaigns() {
    const page = document.querySelector('[data-creator-campaigns]');

    if (!page) {
        return;
    }

    const track = (eventType, metadata) => {
        if (typeof window.gaTrack === 'function') {
            window.gaTrack(eventType, {
                object_id: 'creator_campaigns',
                object_type: 'landing_page',
                metadata: metadata || {},
            });
        }
    };

    track('landing_page_view', {page: 'creator_campaigns'});
    page.querySelectorAll('[data-campaign-cta]').forEach((cta) => {
        cta.addEventListener('click', () => track('landing_page_cta_click', {
            page: 'creator_campaigns',
            placement: cta.dataset.campaignCta,
            destination: 'generator',
        }));
    });

    const introItems = Array.from(page.querySelectorAll('[data-campaign-intro]'));
    const revealItems = Array.from(page.querySelectorAll('[data-campaign-reveal]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
        introItems.concat(revealItems).forEach((item) => item.classList.add('is-visible'));
        return;
    }

    page.classList.add('is-motion-ready');
    window.requestAnimationFrame(() => {
        introItems.forEach((item, index) => {
            window.setTimeout(() => item.classList.add('is-visible'), 100 + (index * 95));
        });
    });

    const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        });
    }, {rootMargin: '0px 0px -8% 0px', threshold: 0});

    revealItems.forEach((item) => revealObserver.observe(item));

    let revealFrame = null;
    const revealPassedItems = () => {
        revealFrame = null;
        revealItems.forEach((item) => {
            if (!item.classList.contains('is-visible') && item.getBoundingClientRect().top < window.innerHeight * 0.92) {
                item.classList.add('is-visible');
                revealObserver.unobserve(item);
            }
        });
    };
    window.addEventListener('scroll', () => {
        if (revealFrame === null) {
            revealFrame = window.requestAnimationFrame(revealPassedItems);
        }
    }, {passive: true});
    revealPassedItems();

    const hero = page.querySelector('.creator-campaign__hero');
    if (hero && window.matchMedia('(pointer: fine)').matches) {
        hero.addEventListener('pointermove', (event) => {
            const bounds = hero.getBoundingClientRect();
            const x = ((event.clientX - bounds.left) / bounds.width) - 0.5;
            const y = ((event.clientY - bounds.top) / bounds.height) - 0.5;
            hero.style.setProperty('--campaign-shift-x', `${x * -9}px`);
            hero.style.setProperty('--campaign-shift-y', `${y * -6}px`);
        });
        hero.addEventListener('pointerleave', () => {
            hero.style.setProperty('--campaign-shift-x', '0px');
            hero.style.setProperty('--campaign-shift-y', '0px');
        });
    }

    const method = page.querySelector('#campaign-method');
    const steps = Array.from(page.querySelectorAll('[data-campaign-step]'));
    const label = page.querySelector('[data-campaign-visual-label]');
    const number = page.querySelector('[data-campaign-visual-number]');
    const labels = ['Identity / Defined', 'Media / In progress', 'Selection / Reviewed', 'Collection / Organized'];

    if (method && steps.length) {
        const stepObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }

                const index = Number(entry.target.dataset.campaignStep || 0);
                method.dataset.campaignActive = String(index);
                steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === index));
                if (label) label.textContent = labels[index];
                if (number) number.textContent = String(index + 1).padStart(2, '0');
            });
        }, {rootMargin: '-35% 0px -45% 0px', threshold: 0});

        steps.forEach((step) => stepObserver.observe(step));
    }
}

export {creatorCampaigns};
